<template>
  <BBPSelect
    :options="input.options"
    :label="input.listLabel"
    :placeholder="input.placeholder"
    :searchable="input.searchable"
    :searchableBy="input.searchableBy"
    :searchableGet="input.searchableGet"
    :disabled="input.disabled"
    :customStyle="input.style"
    :error="errorText"
    :value="value"
    @change="setValue"
    @scrollEnd="scrollEnd"
  />
</template>

<script>
import BBPSelect from '@/components/Main/InputFields/BBPSelect/BBPSelect'
import {get, set} from 'lodash'

export default {
  name: 'BBPSelectInput',
  props: ['input', 'model', 'errorText'],
  components: {BBPSelect},
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    value () {
      const { model } = this.input
      const userId = get(this.userInfo, 'id', '5f8097e4e06d0800124c7a5d')
      const value = get(this.model, model, '')
      const { options = [] } = this.input
      const currentUser = options.find((el) => el._id === userId)
      return this.input.clearable ? value || '' : Object.keys(value).length ? value : currentUser
    }
  },
  methods: {
    setValue (val) {
      this.$emit('error', false)
      set(this.model, this.input.model, val)
      this.$emit('input', val, this.input)
    },
    scrollEnd () {
      this.$emit('scrollEnd')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPForm/BBPSelectInput/BBPSelectInput.vue